import React from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Text, Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { PublicPlayerType } from '../../../objectTypes';

type DirectMessageHeaderType = { navigation:any, playerDetails:PublicPlayerType | undefined, active_ind?:boolean }
function DirectMessageHeader ({ navigation, playerDetails, active_ind }:DirectMessageHeaderType) {

    const insets = useSafeAreaInsets();

    return (
        <View style={Styles.viewStyles.navStyle, { backgroundColor:Colors.brand.electric, paddingTop: insets.top }}>
            <View style={{flexDirection:'row', alignItems:'center'}}>
                <TouchableOpacity style={{padding:17, paddingRight:0, flexDirection:'row', alignItems:'center'}} onPress={() => navigation.goBack()}> 
                    <View style={{ marginRight:12, height:25, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='chevron-left' type='feather' size={16} color={Colors.shades.white} />
                    </View>
                </TouchableOpacity>
                <View style={{marginRight:16}}>
                    <Image style={{height:40, width:40, borderRadius:100}} source={playerDetails?.profile_pic?{ uri: playerDetails.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    <View style={{position:'absolute', bottom:0, right:0, height:12, width:12, borderRadius:100, backgroundColor:active_ind?Colors.activeGreen:Colors.brand.slate}} />
                </View>
                <View>
                    <Text style={Styles.textStyles.whiteRegularLeft14}>{playerDetails?.first_name}{playerDetails?.last_name}</Text>
                    <Text style={Styles.textStyles.primary50RegularLeft12}>@{playerDetails?.username}</Text>
                </View>
            </View>
        </View>
    )
}

export default DirectMessageHeader